import { api, qk, unwrap } from "@/lib/api";

/** Query for the canvas graph of one environment. Shared by the screen and the route loader. */
export function graphQuery(project: string, env: string) {
  return {
    queryKey: qk.graph(project, env),
    queryFn: () => unwrap(api.GET("/v1/projects/{project}/environments/{environment}/graph", { params: { path: { project, environment: env } } })),
  };
}
